import { render, staticRenderFns } from "./VueFlux.vue?vue&type=template&id=91489c50&"
import script from "./VueFlux.vue?vue&type=script&lang=js&"
export * from "./VueFlux.vue?vue&type=script&lang=js&"
import style0 from "./VueFlux.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports